import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import * as mealTypeActions from 'PointOfSale/modules/mealTypes/state/actions';
import MenuButtonListComponent from 'PointOfSale/modules/mealTypes/component/MenuButtonList';
import * as POSSelectors from 'PointOfSale/selectors';
import { DATE_FORMAT_FOR_DB_STRING } from 'Common/Constants';
import { createToast, toastType } from 'Common/ToastHelper';
import { getIsDayClosed } from 'Common/GeneralHelper';
import { MealTypeKeysEnum } from 'Common/Constants/Enumeration/MealTypesEnum';

class MenuButtonList extends Component {
  handleOnClickMenuItem = async menu => {
    const isSupper = menu.label === MealTypeKeysEnum.S;
    const isClosed = await this.checkIfClosed(isSupper);
    if (!isClosed) {
      this.props.mealTypesActions.selectMealType(menu.label);
    }
  };

  checkIfClosed = async isSupper => {
    const { servingDetails } = this.props;

    const { PrimarySiteId, WorkingDate } = servingDetails;

    const ClosingDate = moment(WorkingDate).format(DATE_FORMAT_FOR_DB_STRING);
    try {
      const model = { PrimarySiteId, ClosingDate, Supper: isSupper };

      const isClosed = await getIsDayClosed(model);

      if (isClosed) {
        createToast(
          toastType.error,
          'Error',
          'Please select a meal type and day that has not been closed.',
          true
        );
        return true;
      }
    } catch (error) {
      return false;
    }
    return false;
  };

  render() {
    const { currentSelectedMenu } = this.props;
    return (
      <MenuButtonListComponent
        currentSelectedMenu={currentSelectedMenu}
        handleOnClickMenuItem={this.handleOnClickMenuItem}
      />
    );
  }
}
MenuButtonList.propTypes = {
  handleOnClickMenuItem: PropTypes.func,
  currentSelectedMenu: PropTypes.string,
};
const mapStateToProps = state => ({
  currentSelectedMenu: POSSelectors.getCurrentSelectedMenu(state),
  servingDetails: POSSelectors.getServingDetails(state),
});

const mapDispatchToProps = dispatch => ({
  mealTypesActions: bindActionCreators(mealTypeActions, dispatch),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MenuButtonList)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/mealTypes/container/MenuButtonList.js